const state = {
    queues: []
}

const getters = {
    getStoreQueues(state) {
      return state.queues;
    }
};

const actions = {
    async fetchStoreQueues({ commit }) {
      try {
        const response = await axios.get('dashboard/getQueuesByUser');
        const data = response.data;
        if (Array.isArray(data) && data.length) {
          commit('SET_STORE_QUEUES', data);
        }
      } catch (error) {
        console.error('Erro ao obter filas:', error);
      }
    }
};

const mutations = {
    SET_STORE_QUEUES(state, queues) {
      state.queues = queues;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}
